import { Component, OnInit } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { JwtService } from "../core/services/jwt.service";
import { UserService } from "../core/services/user.service";
import { UserDataService } from "../core/services/user-data.service";
import { environment } from "../../environments/environment.prod";
import { filter } from "rxjs";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.css"],
})
export class HomeComponent implements OnInit {
  version = environment.version;
  workPASStokenExist: boolean = false;
  userToken: any;
  userID: any;
  isProfileComplete: boolean = false;
  userData: any;

  showContent: boolean = false;

  panelOpenState = false;
  hideApplyButton = false;

  constructor(
    private router: Router,
    private jwt: JwtService,
    private userService: UserService
  ) {}

  ngOnInit(): void {
    this.userData = JSON.parse(localStorage.getItem("applicantDetails"));

    this.userToken = this.jwt.getToken();
    this.jwt.getToken() ? this.workPASStokenExist = true : this.workPASStokenExist = false;
    this.userID = localStorage.getItem("userID");
    this.userService.getApplicantDetails(this.userID).subscribe((res) => {
      this.userData = res;
    },
    (error) => {
      this.userData = ""
    });

  }

  onNavigateLogin() {

    this.router.navigate(["login"]);

  }

  onNavigateDashboard() {

    if (this.userData == null) {
      localStorage.clear();
      this.router.navigate(["/"]);
    } else {
      if (this.userData.isProfileComplete == true) {
        this.router.navigate(["user/home"]);
      } else {
        this.router.navigate(["/user/applicant-profilling"]);
      }
    }
  }

  navigateServices() {
    this.router.navigateByUrl("/services");
  }

  navigateServicesGreenCard() {
    this.router.navigateByUrl("/services-green-card");
  }

  isLoginPage(): boolean {
    
    return this.router.url === '/login'

  }

}
